import axios from "axios";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomerExclusiveListItem, ExclusiveListLookupItem } from "../models";

const API_PATH = "customerexclusivelist/";

export const fetchAssignments = createAsyncThunk(
  "customerExclusiveList/fetchAssignments",
  async (data: { customerAccountId: string; supplierAccountId: string }) => {
    const res = await axios.get(`${API_PATH}getassignments`, {
      params: data,
    });
    return res.data.data as CustomerExclusiveListItem[];
  }
);

export const fetchUnassignedLists = createAsyncThunk(
  "customerExclusiveList/fetchUnassigned",
  async (customerAccountId: string) => {
    const res = await axios.get(`${API_PATH}getunassignedlists`, {
      params: { customerAccountId },
    });
    return res.data.data as ExclusiveListLookupItem[];
  }
);

export interface CustomerExclusiveListState {
  assignments: CustomerExclusiveListItem[];
  unassignedLists: ExclusiveListLookupItem[];
  loading: boolean;
  customerAccountId: string;
  supplierAccountId: string;
  pendingListId: string;
}

const initialState: CustomerExclusiveListState = {
  assignments: [],
  unassignedLists: [],
  loading: false,
  customerAccountId: "",
  supplierAccountId: "",
  pendingListId: "",
};

const customerExclusiveListSlice = createSlice({
  name: "customerExclusiveList",
  initialState,
  reducers: {
    setContext: (
      state,
      action: PayloadAction<{
        customerAccountId: string;
        supplierAccountId: string;
      }>
    ) => {
      state.customerAccountId = action.payload.customerAccountId;
      state.supplierAccountId = action.payload.supplierAccountId;
    },
    setPendingList: (state, action: PayloadAction<string>) => {
      state.pendingListId = action.payload;
    },
    clearPendingList: (state) => {
      state.pendingListId = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssignments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAssignments.fulfilled, (state, action) => {
        state.loading = false;
        state.assignments = action.payload;
      })
      .addCase(fetchUnassignedLists.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUnassignedLists.fulfilled, (state, action) => {
        state.unassignedLists = action.payload;
      });
  },
});

export const { setContext, setPendingList, clearPendingList } =
  customerExclusiveListSlice.actions;
export default customerExclusiveListSlice;
